import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { my_routes } from "../router/all_routes";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Table from "../../core/common/dataTable/index";
import { AxiosError } from "axios";
import { UserDataTable } from "../../core/data/interface"; //Les types des colones de notre tableau déclaré au préalable
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { deleteUser, getAllUsers, recoverAccount } from "../../api/users";

// pour restreaindre l'accès à ce composant
import withPermission from "../../core/common/autorisations/withPermission";
import { toast } from "sonner";
import TooltipOption from "./tooltipOption";
import {
  Action,
  buildPermission,
  Resource,
} from "../../core/common/autorisations/permissionsMap";

//  restreindre l'acces à ce composant
const ProtectedAddUser = withPermission(
  (props: any) => (
    <>
      <div className="mb-2">
        <Link
          to={props.routes.newUser}
          className="btn btn-primary d-flex align-items-center me-3"
        >
          <i className="ti ti-square-rounded-plus me-2" />
          Nouveau Personnel
        </Link>
      </div>
      <div className="mb-2">
        <Link
          to={props.routes.department}
          className="btn btn-light d-flex align-items-center"
        >
          Départements
        </Link>
      </div>
    </>
  ),
  [buildPermission(Resource.USER, Action.CREATE)],
  "masquer",
);

// boutton protégée pour modifier un user admin
const ProtectedBtnUpdateUser = withPermission(
  (props: any) => (
    <li>
      <Link
        className="dropdown-item rounded-1"
        to={`/edit-user/${props.record.id}`}
      >
        <i className="ti ti-edit-circle me-2" />
        Modifier
      </Link>
    </li>
  ),
  [buildPermission(Resource.USER, Action.UPDATE)],
  "masquer",
);

// bouton pour réinitialiser un mot de passe
const ProtectedBtnResetPasword = withPermission(
  (props: any) => (
    <li>
      <button
        onClick={() => props.showConfirmationAlert(props.record)}
        className="dropdown-item rounded-1"
      >
        <i className="ti ti-menu me-2" />
        Mot de passe
      </button>
    </li>
  ),
  [buildPermission(Resource.USER, Action.UPDATE)],
  "masquer",
);

// boutton protégée pour supprimer un user admin
const ProtectedBtnDeleteUser = withPermission(
  (props: any) => (
    <li>
      <button
        className="dropdown-item rounded-1"
        onClick={() => props.showDeleteAlert(props.record)}
      >
        <i className="ti ti-trash-x me-2" />
        Supprimer
      </button>
    </li>
  ),
  [buildPermission(Resource.USER, Action.DELETE)],
  "masquer",
);

const AllUser = () => {
  const routes = my_routes;
  //Initialisation des state utilisés
  const [allUsers, setAllUsers] = useState([]);
  const [isLoading, setIsLoading] = useState(true); // Pour le vrai chargement
  const [hasLoaded, setHasLoaded] = useState(false); // Pour éviter "Chargement..." quand il n'y a juste pas de données

  const [refreshKey, setRefreshKey] = useState(0);

  //Initialisation de sweetAlert
  const MySwal = withReactContent(Swal);

  // Les colonnes de notre tableau
  const columns = [
    {
      title: "Nom et Prénom",
      dataIndex: "firstname",
      render: (text: string, record: any) => (
        <div className="d-flex align-items-center">
          <div className="ms-2">
            <p className="text-dark mb-0">
              <Link
                to={routes.login}
              >{`${record.firstname} ${record.lastname}`}</Link>
            </p>
          </div>
        </div>
      ),
      sorter: (a: UserDataTable, b: UserDataTable) =>
        a.firstname.length - b.firstname.length,
    },
    {
      title: "Sexe",
      dataIndex: "sexe",
      sorter: (a: UserDataTable, b: UserDataTable) =>
        a.sexe.length - b.sexe.length,
    },
    {
      title: "Département",
      dataIndex: "Department",
      render: (department: any) => department?.label || "-", // Affiche le label ou un tiret si absent
      sorter: (a: UserDataTable, b: UserDataTable) => {
        const labelA = a.Department?.label || "";
        const labelB = b.Department?.label || "";
        return labelA.localeCompare(labelB);
      },
    },
    {
      title: "Fonction",
      dataIndex: "jobFunction",
      sorter: (a: UserDataTable, b: UserDataTable) =>
        a.jobFunction.length - b.jobFunction.length,
    },
    {
      title: "Email",
      dataIndex: "email",
      sorter: (a: UserDataTable, b: UserDataTable) =>
        a.email.length - b.email.length,
    },
    {
      title: "Téléphone",
      dataIndex: "number",
      sorter: (a: UserDataTable, b: UserDataTable) =>
        a.number.length - b.number.length,
    },
    {
      title: "Statut",
      dataIndex: "statut",
      render: (text: boolean) => (
        <>
          {text === true ? (
            <span className="badge badge-soft-success d-inline-flex align-items-center">
              <i className="ti ti-circle-filled fs-5 me-1"></i>
              Actif
            </span>
          ) : (
            <span className="badge badge-soft-danger d-inline-flex align-items-center">
              <i className="ti ti-circle-filled fs-5 me-1"></i>
              Inactif
            </span>
          )}
        </>
      ),
      sorter: (a: UserDataTable, b: UserDataTable) =>
        a.statut === b.statut ? 0 : a.statut ? -1 : 1,
    },
    {
      title: "Date d'inscription",
      dataIndex: "createdAt",
      render: (date: string) => {
        const d = new Date(date);
        return d.toLocaleDateString("fr-FR", {
          year: "numeric",
          month: "long",
          day: "numeric",
        });
      },
      sorter: (a: UserDataTable, b: UserDataTable) =>
        new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime(),
    },
    {
      title: "Action",
      dataIndex: "action",
      render: (_: any, record: any) => {
        return (
          <>
            <div className="d-flex align-items-center">
              <div className="dropdown">
                <Link
                  to="#"
                  className="btn btn-white btn-icon btn-sm d-flex align-items-center justify-content-center rounded-circle p-0"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <i className="ti ti-dots-vertical fs-14" />
                </Link>
                <ul className="dropdown-menu dropdown-menu-right p-3">
                  {/* gérer permissions */}
                  <li>
                    <Link
                      className="dropdown-item rounded-1"
                      to={routes.rolesPermissions}
                      state={{ userId: record.id, name: `${record.firstname} ${record.lastname}` }}
                    >
                      <i className="ti ti-shield-plus me-2" />
                      Role & Permission
                    </Link>
                  </li>
                  {/* modifier un user admin */}
                  <ProtectedBtnUpdateUser record={record} />

                  {/* réinitialiser un mot de passe */}
                  <ProtectedBtnResetPasword
                    showConfirmationAlert={showConfirmationAlert}
                    record={record}
                  />

                  {/* supprimer un user admin */}
                  <ProtectedBtnDeleteUser
                    showDeleteAlert={showDeleteAlert}
                    record={record}
                  />
                </ul>
              </div>
            </div>
          </>
        );
      },
    },
  ];

  //Traitement en alert de la demande de réinitialisation de mot de passe
  const showConfirmationAlert = (user: any) => {
    MySwal.fire({
      title: "Réinitialiser mot de passe ?",
      text: `Un e-mail contenant un lien sécurisé lui sera envoyé à ${user.firstname} ${user.lastname} pour lui permettre de définir un nouveau mot de passe.`,
      showCancelButton: true,
      // confirmButtonColor: "#00ff00",
      confirmButtonText: "Envoyer!",
      // cancelButtonColor: "#ff0000",
      cancelButtonText: "Annuler",
    }).then(async (result) => {
      if (result.isConfirmed) {
        // ── Affiche le spinner pendant la requête ──
        MySwal.fire({
          title: "Réinitialisation en cours...",
          allowOutsideClick: false,
          allowEscapeKey: false,
          showConfirmButton: false,
          didOpen: () => MySwal.showLoading(),
        });
        try {
          //On lance la requête d'envoi de mail
          await recoverAccount(user.email);
          MySwal.fire({
            title: "Lien envoyé avec succès !",
            icon: "success",
            confirmButtonText: "OK",
          });
        } catch (error) {
          //On affiche une alerte en cas d'erreur côté serveur
          MySwal.fire({
            title: "Erreur",
            text: "Échec de l'envoi de l'e-mail. Veuillez réessayer.",
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      }
    });
  };

  //Traitement en alert de la demande de suppression d'un compte
  const showDeleteAlert = (user: any) => {
    MySwal.fire({
      title: "Supprimer un personnel administratif ?",
      text: `Souhaitez-vous vraiment supprimer l'utilisateur ${user.firstname}  ${user.lastname} ?`,
      showCancelButton: true,
      // confirmButtonColor: "#00ff00",
      confirmButtonText: "Supprimer !",
      // cancelButtonColor: "#ff0000",
      cancelButtonText: "Annuler",
    }).then(async (result) => {
      if (result.isConfirmed) {
        // ── Affiche le spinner pendant la requête ──
        MySwal.fire({
          title: "Suppression en cours...",
          allowOutsideClick: false,
          allowEscapeKey: false,
          showConfirmButton: false,
          didOpen: () => MySwal.showLoading(),
        });
        try {
          //On lance la requête de suppression
          await deleteUser(user.id);
          MySwal.fire({
            title: "Utilisateur supprimé avec succès !",
            icon: "success",
            confirmButtonText: "OK",
          });
          // Relancer le useEffect
          reloadData();
        } catch (err: any) {
          // console.log(err);

          //On affiche une alerte en cas d'erreur côté serveur
          MySwal.fire({
            title: "Erreur",
            text:
              err.response?.data?.message ||
              err.response?.data?.error ||
              "Une erreur est survenue, réessayez plus tard",
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      }
    });
  };

  //Reload de la liste
  const reloadData = () => setRefreshKey((prev) => prev + 1);

  const fetchAllUser = () => {
    getAllUsers()
      .then((users) => {
        // console.log(users)
        setAllUsers(users);
      })
      .catch((error) => {
        // console.error("Error: ", error);
        toast.error(
        error.response?.data?.message ||
        error.response?.data?.error ||
        error.message ||
        "Une erreur s'est produit, Réessayer plus tard",
      );
      })
      .finally(() => {
        setIsLoading(false); //Les données ne sont plus en chargement
        setHasLoaded(true); //Les données ont été chargé avec succès
      });
  };
  //On recupère la liste des Users en appelant sa fonction
  useEffect(() => {
    fetchAllUser();
  }, [refreshKey]);

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          {/* Page Header */}
          <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
            <div className="my-auto mb-2">
              <h3 className="page-title mb-1">Personnels Administratifs</h3>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={routes.login}>Comptes</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Personnel Administratif
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center">
              <TooltipOption updateData={fetchAllUser} />
              {/* Boutton en entête de la page */}
              <ProtectedAddUser routes={routes} />
            </div>
          </div>
          {/* /Page Header */}
          {/* {!selectedYear?.statut &&<InfosAlertYearDisabled />} */}
          {/* Tableau liste du personnel administratif */}
          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap pb-0">
              <h4 className="mb-3">Liste du Personnel</h4>
              <div className="d-flex align-items-center flex-wrap">
                <div className="input-icon-start mb-3 me-2 position-relative">
                  {/* <PredefinedDateRanges /> */}
                </div>
              </div>
            </div>
            <div className="card-body p-0 py-3">
              {/* Staffs List (On affiche le tableau qui si les données son chargées même vide) */}
              {isLoading && !hasLoaded ? (
                <div className="text-center">
                  <div className="spinner-border" role="status"></div>
                  <span className="visually">Chargement des Données...</span>
                </div>
              ) : (
                <Table
                  columns={columns}
                  dataSource={allUsers}
                  Selection={true}
                />
              )}
              {/* /Staffs List */}
            </div>
          </div>
        </div>
        {/* /Page Header */}
      </div>
    </>
  );
};

// export default withPermission(AllUser, "admin:access", "accès-refuser");
export default AllUser;
